import { GraphQLClient } from 'graphql-request';
import { BASE_URL_API, BASE_URL_UPLOAD, URL_END_POINT, BASE_URL_API_NEW, BASE_URL_UPLOAD_FILE ,URL_IMPORT_USER_REMOVE} from './Url';
import axios from 'axios';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const alertSweet = withReactContent(Swal)
const requestGql = (query = '', variables = {}) => {
    return new Promise((resolve, reject) => {
        let client = new GraphQLClient(BASE_URL_API, {
            headers: {
                authorization: localStorage.getItem('mhc') || null
            }
        });
        client
            .request(query, variables)
            .then(result => {
                resolve(result);
            })
            .catch(err => {
                reject(err);
            });
    });
};

const requestGqlNew = (query = '', variables = {}) => {
    return new Promise((resolve, reject) => {
        let client = new GraphQLClient(BASE_URL_API_NEW, {
            headers: {
                authorization: localStorage.getItem('mhc') || null
            }
        });
        client
            .request(query, variables)
            .then(result => {
                resolve(result);
            })
            .catch(err => {
                reject(err);
            });
    });
};

const requestUploadImage = async file => {
    try {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers':
                    'Accept, Accept-CH, Accept-Charset, Accept-Datetime, Accept-Encoding, Accept-Ext, Accept-Features, Accept-Language, Accept-Params, Accept-Ranges, Access-Control-Allow-Credentials, Access-Control-Allow-Headers, Access-Control-Allow-Methods, Access-Control-Allow-Origin, Access-Control-Expose-Headers, Access-Control-Max-Age, Access-Control-Request-Headers, Access-Control-Request-Method, Age, Allow, Alternates, Authentication-Info, Authorization, C-Ext, C-Man, C-Opt, C-PEP, C-PEP-Info, CONNECT, Cache-Control, Compliance, Connection, Content-Base, Content-Disposition, Content-Encoding, Content-ID, Content-Language, Content-Length, Content-Location, Content-MD5, Content-Range, Content-Script-Type, Content-Security-Policy, Content-Style-Type, Content-Transfer-Encoding, Content-Type, Content-Version, Cookie, Cost, DAV, DELETE, DNT, DPR, Date, Default-Style, Delta-Base, Depth, Derived-From, Destination, Differential-ID, Digest, ETag, Expect, Expires, Ext, From, GET, GetProfile, HEAD, HTTP-date, Host, IM, If, If-Match, If-Modified-Since, If-None-Match, If-Range, If-Unmodified-Since, Keep-Alive, Label, Last-Event-ID, Last-Modified, Link, Location, Lock-Token, MIME-Version, Man, Max-Forwards, Media-Range, Message-ID, Meter, Negotiate, Non-Compliance, OPTION, OPTIONS, OWS, Opt, Optional, Ordering-Type, Origin, Overwrite, P3P, PEP, PICS-Label, POST, PUT, Pep-Info, Permanent, Position, Pragma, ProfileObject, Protocol, Protocol-Query, Protocol-Request, Proxy-Authenticate, Proxy-Authentication-Info, Proxy-Authorization, Proxy-Features, Proxy-Instruction, Public, RWS, Range, Referer, Refresh, Resolution-Hint, Resolver-Location, Retry-After, Safe, Sec-Websocket-Extensions, Sec-Websocket-Key, Sec-Websocket-Origin, Sec-Websocket-Protocol, Sec-Websocket-Version, Security-Scheme, Server, Set-Cookie, Set-Cookie2, SetProfile, SoapAction, Status, Status-URI, Strict-Transport-Security, SubOK, Subst, Surrogate-Capability, Surrogate-Control, TCN, TE, TRACE, Timeout, Title, Trailer, Transfer-Encoding, UA-Color, UA-Media, UA-Pixels, UA-Resolution, UA-Windowpixels, URI, Upgrade, User-Agent, Variant-Vary, Vary, Version, Via, Viewport-Width, WWW-Authenticate, Want-Digest, Warning, Width, X-Content-Duration, X-Content-Security-Policy, X-Content-Type-Options, X-CustomHeader, X-DNSPrefetch-Control, X-Forwarded-For, X-Forwarded-Port, X-Forwarded-Proto, X-Frame-Options, X-Modified, X-OTHER, X-PING, X-PINGOTHER, X-Powered-By, X-Requested-With',
                'Access-Control-Allow-Methods':
                    'CONNECT, DEBUG, DELETE, DONE, GET, HEAD, HTTP, HTTP/0.9, HTTP/1.0, HTTP/1.1, HTTP/2, OPTIONS, ORIGIN, ORIGINS, PATCH, POST, PUT, QUIC, REST, SESSION, SHOULD, SPDY, TRACE, TRACK',
                authorization: localStorage.getItem('mhc') || null
            }
        };
        let avatar = new FormData();
        avatar.append('file', file);
        let picture = await axios.post(BASE_URL_UPLOAD, avatar, config);
        if(picture.data.success) {
            return picture.data.filePaths.file;
        }else{
            alertSweet(picture.data.message)
        }
    } catch (err) {
        console.log('Error upload image', err);
    }
};

const requestUploadFile = async file => {
    try {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers':
                    'Accept, Accept-CH, Accept-Charset, Accept-Datetime, Accept-Encoding, Accept-Ext, Accept-Features, Accept-Language, Accept-Params, Accept-Ranges, Access-Control-Allow-Credentials, Access-Control-Allow-Headers, Access-Control-Allow-Methods, Access-Control-Allow-Origin, Access-Control-Expose-Headers, Access-Control-Max-Age, Access-Control-Request-Headers, Access-Control-Request-Method, Age, Allow, Alternates, Authentication-Info, Authorization, C-Ext, C-Man, C-Opt, C-PEP, C-PEP-Info, CONNECT, Cache-Control, Compliance, Connection, Content-Base, Content-Disposition, Content-Encoding, Content-ID, Content-Language, Content-Length, Content-Location, Content-MD5, Content-Range, Content-Script-Type, Content-Security-Policy, Content-Style-Type, Content-Transfer-Encoding, Content-Type, Content-Version, Cookie, Cost, DAV, DELETE, DNT, DPR, Date, Default-Style, Delta-Base, Depth, Derived-From, Destination, Differential-ID, Digest, ETag, Expect, Expires, Ext, From, GET, GetProfile, HEAD, HTTP-date, Host, IM, If, If-Match, If-Modified-Since, If-None-Match, If-Range, If-Unmodified-Since, Keep-Alive, Label, Last-Event-ID, Last-Modified, Link, Location, Lock-Token, MIME-Version, Man, Max-Forwards, Media-Range, Message-ID, Meter, Negotiate, Non-Compliance, OPTION, OPTIONS, OWS, Opt, Optional, Ordering-Type, Origin, Overwrite, P3P, PEP, PICS-Label, POST, PUT, Pep-Info, Permanent, Position, Pragma, ProfileObject, Protocol, Protocol-Query, Protocol-Request, Proxy-Authenticate, Proxy-Authentication-Info, Proxy-Authorization, Proxy-Features, Proxy-Instruction, Public, RWS, Range, Referer, Refresh, Resolution-Hint, Resolver-Location, Retry-After, Safe, Sec-Websocket-Extensions, Sec-Websocket-Key, Sec-Websocket-Origin, Sec-Websocket-Protocol, Sec-Websocket-Version, Security-Scheme, Server, Set-Cookie, Set-Cookie2, SetProfile, SoapAction, Status, Status-URI, Strict-Transport-Security, SubOK, Subst, Surrogate-Capability, Surrogate-Control, TCN, TE, TRACE, Timeout, Title, Trailer, Transfer-Encoding, UA-Color, UA-Media, UA-Pixels, UA-Resolution, UA-Windowpixels, URI, Upgrade, User-Agent, Variant-Vary, Vary, Version, Via, Viewport-Width, WWW-Authenticate, Want-Digest, Warning, Width, X-Content-Duration, X-Content-Security-Policy, X-Content-Type-Options, X-CustomHeader, X-DNSPrefetch-Control, X-Forwarded-For, X-Forwarded-Port, X-Forwarded-Proto, X-Frame-Options, X-Modified, X-OTHER, X-PING, X-PINGOTHER, X-Powered-By, X-Requested-With',
                'Access-Control-Allow-Methods':
                    'CONNECT, DEBUG, DELETE, DONE, GET, HEAD, HTTP, HTTP/0.9, HTTP/1.0, HTTP/1.1, HTTP/2, OPTIONS, ORIGIN, ORIGINS, PATCH, POST, PUT, QUIC, REST, SESSION, SHOULD, SPDY, TRACE, TRACK',
                authorization: localStorage.getItem('mhc') || null
            }
        };
        let certificate = await Promise.all(
            file.map(data => {
                if (data.size) {
                    const certif = new FormData();
                    certif.append('file', data);
                    return axios
                        .post(BASE_URL_UPLOAD_FILE, certif, config)
                        .then(res => {
                            if(res.data.success) {
                                return res.data.filePaths[0];
                            }else{
                                alertSweet(res.data.message)
                            }
                        });
                } else {
                    return data.name;
                }
            })
        );
        return certificate;
    } catch (err) {
        console.log('Error upload file', err);
    }
};
const requestImportCSV = async file => {
    try {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': `*`,
                authorization: localStorage.getItem('mhc') || null
            }
        };
        let csv = new FormData();
        csv.append('file', file[0]);

        let image = await axios.post(`${URL_END_POINT}`, csv, config);
        if (image.status !== 200) {
            return alertSweet(image.data.message);
        } else {
            return image.data.filePaths.file;
        }
    } catch (err) {
        console.log('Error import csv', err);
    }
};

const executeQueryToAPI = (queryName, responseObject, variables, query) => {
    return  new Promise((resolve, reject)=>{
        requestGql(query, variables).then(result => {
            if (result[queryName]) {
                let data = result[queryName][responseObject] || [];
                resolve({
                    responseObject:data,
                    fullResponse: result[queryName]
                });
            }
        })
            .catch(err=>{
                reject(err);
            });
    })
}

const executeQueryToMarketPlace = (queryName, responseObject, variables, query) => {
    return  new Promise((resolve, reject)=>{
        requestGqlNew(query, variables).then(result => {
            if (result[queryName]) {
                let data = result[queryName][responseObject] || [];
                resolve({
                    responseObject:data,
                    fullResponse: result[queryName]
                });
            }
        })
            .catch(err=>{
                reject(err);
            });
    })
}

const requestImportCSVUserRemove = async file => {
    try {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': `*`,
                authorization: localStorage.getItem('mhc') || null
            }
        };
        let csv = new FormData();
        csv.append('file', file[0]);

        let image = await axios.post(`${URL_IMPORT_USER_REMOVE}`, csv, config);
        if (image.status !== 200) {
            return alertSweet(image.data.message);
        } else {
            return image.data.filePaths.file;
        }
    } catch (err) {
        console.log('Error import csv', err);
    }
};
export { requestGql, requestUploadImage, requestImportCSV, requestUploadFile, requestGqlNew, executeQueryToAPI, executeQueryToMarketPlace, requestImportCSVUserRemove };
